import React from "react";

// Set default icon color
//
// To add a new color, create a new case with the value and
// name of the color.

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="116"
      height="24"
      fill="none"
      viewBox="0 0 116 24"
    >
      <path
        fill="#00FF7F"
        d="M19.4012 6.41189C18.7044 4.43245 17.5461 2.87133 15.9264 1.72854C14.3066 0.585756 12.4045 0.0143623 10.22 0.0143623C7.91872 0.0143623 5.93529 0.585448 4.26971 1.72762C2.60412 2.86979 1.43821 4.44597 0.771976 6.45614C0.256714 7.94872 -0.000610138 9.77632 1.08631e-06 11.9389C1.08631e-06 14.01 0.272299 15.8677 0.8169 17.5121C1.48313 19.5536 2.64935 21.1452 4.31555 22.2867C5.98175 23.4283 7.93492 23.9994 10.1751 24C12.3859 24 14.3088 23.4289 15.9438 22.2867C17.5788 21.1446 18.7313 19.5533 19.4012 17.513C19.9458 15.8994 20.2184 14.0263 20.219 11.8938C20.2159 9.79261 19.9433 7.96531 19.4012 6.41189ZM10.3575 14.6877L12.2297 9.53872H17.7811C17.8809 10.3197 17.9296 11.1064 17.9269 11.8938C17.9312 12.8289 17.8641 13.7629 17.7261 14.6877H10.3575ZM2.49838 14.6877C2.36056 13.7784 2.29312 12.8597 2.29668 11.9399C2.29344 11.1387 2.33876 10.338 2.43237 9.54241H9.78907L7.91688 14.6914L2.49838 14.6877ZM17.2347 7.17907C17.2411 7.19659 17.2475 7.21596 17.253 7.23348H13.0631L14.4228 3.49252C14.4842 3.53309 14.5456 3.57366 14.6061 3.61608C15.8365 4.4847 16.6965 5.65023 17.2347 7.17907ZM2.94213 7.19936V7.18553C3.44914 5.65392 4.30455 4.49208 5.55695 3.6336C6.84052 2.75023 8.36797 2.32053 10.2154 2.32053C10.9224 2.31496 11.6273 2.39765 12.314 2.56673L10.6179 7.23348H2.92562C2.92562 7.22702 2.92563 7.21964 2.93296 7.21319L2.94213 7.19936ZM3.06315 16.993H7.07431L5.79624 20.508C5.73298 20.4674 5.6688 20.4259 5.60646 20.3826C4.41182 19.5629 3.57841 18.4563 3.06315 16.993ZM14.6336 20.3927C13.3803 21.2678 11.9207 21.6938 10.1723 21.6938C9.40673 21.6984 8.64366 21.6054 7.9013 21.4172L9.51218 16.9911H17.1476C16.6332 18.4563 15.8099 19.5748 14.6336 20.3927Z"
      />
      <path
        fill="#000000"
        d="M30.8671 18.7053C30.0475 18.3789 29.4124 17.9304 28.962 17.36C28.5251 16.8284 28.2862 16.1602 28.2862 15.4706V15.1718C28.2798 15.1341 28.2825 15.0953 28.2941 15.0588C28.3056 15.0223 28.3257 14.9891 28.3527 14.962C28.3796 14.9349 28.4126 14.9147 28.4489 14.9031C28.4852 14.8915 28.5237 14.8888 28.5613 14.8952H30.5068C30.544 14.8898 30.5819 14.8933 30.6175 14.9053C30.6531 14.9174 30.6854 14.9377 30.7117 14.9646C30.738 14.9916 30.7577 15.0244 30.7691 15.0604C30.7805 15.0963 30.7833 15.1345 30.7773 15.1718V15.3074C30.7773 15.8151 31.0523 16.2593 31.6024 16.6398C32.1525 17.0203 32.8509 17.2106 33.6974 17.2106C34.5079 17.2106 35.1656 17.0338 35.6704 16.6804C36.1753 16.3269 36.4278 15.8785 36.4278 15.335C36.4278 14.8094 36.1933 14.4151 35.7245 14.152C35.2557 13.8889 34.499 13.6122 33.4545 13.3221C32.5759 13.0837 31.7135 12.7886 30.8726 12.4387C30.1974 12.1538 29.5964 11.7165 29.116 11.1607C28.6386 10.6074 28.3999 9.89619 28.3999 9.02696C28.3999 7.81286 28.8727 6.84773 29.8183 6.13157C30.7638 5.4154 32.0208 5.05763 33.5892 5.05825C34.6344 5.05825 35.558 5.22576 36.3599 5.56079C37.1618 5.89582 37.7789 6.3624 38.211 6.96053C38.6385 7.5427 38.8663 8.24884 38.8601 8.97255V9.05093C38.8653 9.08787 38.8619 9.12553 38.8502 9.16091C38.8384 9.1963 38.8186 9.22845 38.7924 9.25484C38.7662 9.28122 38.7342 9.3011 38.699 9.31293C38.6638 9.32475 38.6264 9.32818 38.5897 9.32295H36.6918C36.6551 9.32822 36.6177 9.3248 36.5825 9.31298C36.5474 9.30116 36.5154 9.28125 36.4893 9.25485C36.4631 9.22844 36.4434 9.19626 36.4318 9.16086C36.4202 9.12546 36.4169 9.08782 36.4223 9.05093V8.96979C36.4223 8.44419 36.1652 8.00466 35.6512 7.65119C35.1372 7.29772 34.4391 7.12098 33.5571 7.12098C32.7625 7.12098 32.1183 7.27466 31.6244 7.58203C31.1306 7.8894 30.8827 8.30618 30.8809 8.83239C30.8809 9.35861 31.1196 9.75818 31.5969 10.0311C32.0743 10.3041 32.8448 10.5939 33.9083 10.9007C34.7927 11.1378 35.6635 11.4238 36.5167 11.7573C37.1967 12.0294 37.8035 12.4587 38.288 13.0104C38.7739 13.5637 39.0184 14.2842 39.0215 15.1718C39.0215 16.4013 38.5395 17.3799 37.5756 18.1078C36.6117 18.8356 35.3282 19.198 33.7249 19.1949C32.64 19.1943 31.6874 19.0311 30.8671 18.7053ZM44.0146 18.2295C43.0232 17.5496 42.3294 16.6029 41.9334 15.3894C41.61 14.4102 41.448 13.3037 41.4474 12.0699C41.4474 10.7826 41.6002 9.69517 41.9059 8.8075C42.2655 7.66114 42.9987 6.67007 43.9871 5.99417C44.9785 5.31428 46.1588 4.97433 47.5279 4.97433C48.8255 4.97433 49.9563 5.31428 50.9202 5.99417C51.8841 6.67407 52.5732 7.60293 52.9877 8.78076C53.3122 9.70286 53.4745 10.79 53.4745 12.0422C53.4745 13.311 53.3122 14.4258 52.9877 15.3867C52.5916 16.6008 51.907 17.5475 50.9339 18.2267C49.9609 18.906 48.817 19.2469 47.5022 19.2493C46.1685 19.2493 45.006 18.9094 44.0146 18.2295ZM49.3937 16.3853C49.9346 15.9771 50.3221 15.4017 50.5562 14.6591C50.7542 13.97 50.8533 13.118 50.8533 12.1031C50.8533 11.0882 50.7631 10.2454 50.5828 9.57468C50.3487 8.83209 49.9615 8.2567 49.4212 7.84851C48.8808 7.44033 48.2232 7.23655 47.4481 7.23716C46.7598 7.2207 46.0856 7.43443 45.531 7.84483C44.9907 8.25362 44.6035 8.82901 44.3694 9.571C44.1659 10.2079 44.0656 11.0507 44.0687 12.0994C44.0717 13.1481 44.1711 14.0001 44.3666 14.6555C44.583 15.3987 44.966 15.9741 45.5154 16.3816C46.0649 16.7892 46.7272 16.993 47.5022 16.993C48.1827 17.0059 48.8481 16.7908 49.3937 16.3816V16.3853ZM56.1782 18.7634V0.274395C56.1731 0.237541 56.1765 0.199984 56.1882 0.164676C56.1999 0.129369 56.2196 0.097272 56.2457 0.0709101C56.2718 0.0445481 56.3037 0.024639 56.3387 0.012747C56.3738 0.000855084 56.4111 -0.0026956 56.4478 0.00237455H58.5024C58.5392 -0.00285388 58.5766 0.00057957 58.6118 0.0124009C58.647 0.0242223 58.6789 0.0441088 58.7052 0.0704908C58.7314 0.0968727 58.7512 0.129027 58.7629 0.164414C58.7747 0.199802 58.7781 0.237453 58.7729 0.274395V18.7597C58.7789 18.797 58.7761 18.8352 58.7647 18.8712C58.7533 18.9072 58.7336 18.94 58.7073 18.9669C58.681 18.9938 58.6487 19.0142 58.6131 19.0262C58.5775 19.0383 58.5396 19.0417 58.5024 19.0363H56.446C56.4088 19.0418 56.3709 19.0383 56.3354 19.0263C56.2998 19.0142 56.2676 18.9939 56.2413 18.9669C56.215 18.94 56.1955 18.9071 56.1842 18.8711C56.1729 18.8351 56.1702 18.7969 56.1764 18.7597L56.1782 18.7634ZM70.2709 5.5654C71.0442 5.9154 71.7011 6.48163 72.1633 7.19659C72.6082 7.9081 72.8382 8.73424 72.8252 9.57468V18.7634C72.8316 18.8012 72.829 18.8399 72.8174 18.8764C72.8058 18.9129 72.7858 18.9461 72.7588 18.9732C72.7319 19.0003 72.6989 19.0205 72.6626 19.0321C72.6263 19.0438 72.5877 19.0465 72.5502 19.04H70.4965C70.4593 19.0456 70.4213 19.0423 70.3856 19.0303C70.3499 19.0183 70.3175 18.998 70.2912 18.971C70.2648 18.9441 70.2451 18.9112 70.2338 18.8751C70.2225 18.839 70.2198 18.8007 70.226 18.7634V17.7814C70.226 17.6892 70.1811 17.6726 70.0912 17.727C69.6089 18.2256 69.0228 18.6107 68.3749 18.8547C67.6533 19.1258 66.8879 19.2596 66.1177 19.2493C64.7834 19.2493 63.6795 18.9094 62.8061 18.2295C61.9326 17.5496 61.4959 16.5212 61.4959 15.1442C61.4959 13.7303 61.9867 12.6204 62.9683 11.8145C63.95 11.0085 65.3252 10.6053 67.0941 10.6047H70.1197C70.1345 10.6077 70.1499 10.607 70.1644 10.6026C70.1789 10.5983 70.1921 10.5903 70.2029 10.5795C70.2136 10.5687 70.2215 10.5555 70.2258 10.5409C70.2302 10.5263 70.2309 10.5108 70.2279 10.4959V9.75818C70.2279 8.95903 69.998 8.33815 69.5384 7.89554C69.0787 7.45293 68.3804 7.23225 67.4434 7.23348C66.6873 7.23348 66.0703 7.38316 65.5923 7.68254C65.37 7.81107 65.177 7.98507 65.0257 8.19329C64.8744 8.40152 64.7682 8.63934 64.714 8.89141C64.6602 9.07583 64.552 9.15759 64.3894 9.13669L62.2 8.837C62.0167 8.80104 61.9387 8.72912 61.9571 8.62031C62.1013 7.55068 62.6688 6.67622 63.6596 5.99694C64.6504 5.31766 65.8937 4.97771 67.3893 4.9771C68.4895 4.9771 69.4495 5.17197 70.2691 5.56171L70.2709 5.5654ZM69.1762 16.2894C69.8792 15.7823 70.2306 15.1389 70.2306 14.3595V12.7522C70.2336 12.7373 70.2329 12.7218 70.2286 12.7072C70.2242 12.6926 70.2163 12.6794 70.2056 12.6686C70.1949 12.6578 70.1817 12.6499 70.1672 12.6455C70.1526 12.6411 70.1373 12.6404 70.1224 12.6434H67.5819C66.5183 12.6434 65.6715 12.8518 65.0413 13.2686C64.4111 13.6854 64.0957 14.2654 64.0951 15.0086C64.0951 15.6787 64.3338 16.1861 64.8112 16.531C65.2886 16.8759 65.9147 17.048 66.6898 17.0474C67.6439 17.0474 68.4721 16.7935 69.1744 16.2857L69.1762 16.2894ZM83.1213 5.41233C83.2469 5.46673 83.2928 5.57554 83.2561 5.73875L82.8243 7.77751C82.8059 7.94042 82.6977 7.99482 82.4997 7.94072C82.1553 7.8065 81.788 7.74165 81.4188 7.74985L81.0401 7.77751C80.193 7.81317 79.4946 8.10762 78.9451 8.66088C78.3956 9.21414 78.1206 9.93461 78.12 10.8223V18.7597C78.1262 18.7974 78.1233 18.8361 78.1117 18.8725C78.1001 18.9089 78.08 18.942 78.0531 18.9691C78.0262 18.9961 77.9933 19.0163 77.9571 19.028C77.9209 19.0397 77.8824 19.0426 77.8449 19.0363H75.7912C75.754 19.042 75.716 19.0386 75.6803 19.0266C75.6446 19.0146 75.6123 18.9943 75.5859 18.9673C75.5595 18.9404 75.5399 18.9075 75.5285 18.8714C75.5172 18.8353 75.5145 18.797 75.5207 18.7597V5.46673C75.5155 5.42979 75.519 5.39214 75.5307 5.35675C75.5425 5.32137 75.5622 5.28921 75.5885 5.26283C75.6147 5.23645 75.6467 5.21656 75.6819 5.20474C75.7171 5.19292 75.7545 5.18949 75.7912 5.19471H77.8449C77.882 5.18868 77.92 5.19151 77.9558 5.20297C77.9915 5.21443 78.0242 5.23421 78.0509 5.26069C78.0777 5.28718 78.0979 5.31963 78.1099 5.35542C78.1219 5.39122 78.1254 5.42935 78.12 5.46673V6.90705C78.12 6.96146 78.1337 6.99373 78.1603 6.99926C78.1869 7.00479 78.2098 6.99465 78.2282 6.95777C79.0387 5.69019 80.1468 5.05609 81.5526 5.05548C82.0961 5.04893 82.6335 5.17118 83.1213 5.41233ZM93.8071 18.8436L87.9136 0.328798L87.8861 0.219991C87.8861 0.0936638 87.9677 0.0300392 88.13 0.0300392H89.5896C89.66 0.0243882 89.7303 0.0426727 89.7891 0.0819636C89.848 0.121254 89.892 0.179275 89.9142 0.24673L94.8339 16.1797C94.8404 16.1959 94.8515 16.2097 94.8659 16.2194C94.8803 16.2291 94.8973 16.2342 94.9146 16.2341C94.9319 16.2337 94.9488 16.2284 94.9632 16.2188C94.9777 16.2091 94.9891 16.1956 94.9962 16.1797L99.9159 0.24673C99.9381 0.179275 99.9821 0.121254 100.041 0.0819636C100.1 0.0426727 100.17 0.0243882 100.24 0.0300392H101.674C101.872 0.0300392 101.944 0.129625 101.89 0.328798L95.9424 18.8436C95.9205 18.9113 95.8766 18.9697 95.8177 19.0092C95.7588 19.0486 95.6884 19.067 95.6178 19.0612H94.1307C94.0603 19.0668 93.9901 19.0483 93.9314 19.0089C93.8727 18.9694 93.8289 18.9112 93.8071 18.8436ZM114.554 1.47036C115.518 2.44963 116 3.73657 116 5.33119C116 6.90797 115.509 8.17678 114.528 9.13761C113.546 10.0984 112.253 10.5789 110.648 10.5789H105.377C105.362 10.5758 105.346 10.5765 105.332 10.5809C105.317 10.5853 105.304 10.5932 105.293 10.604C105.283 10.6148 105.275 10.6281 105.27 10.6427C105.266 10.6573 105.265 10.6727 105.268 10.6877V18.7892C105.274 18.8266 105.27 18.8647 105.258 18.9005C105.246 18.9363 105.226 18.9688 105.199 18.9953C105.173 19.0217 105.14 19.0415 105.104 19.053C105.068 19.0644 105.03 19.0673 104.993 19.0612H103.618C103.581 19.0665 103.544 19.0631 103.509 19.0513C103.474 19.0394 103.442 19.0195 103.416 18.9931C103.389 18.9667 103.37 18.9345 103.358 18.8992C103.346 18.8638 103.343 18.8261 103.349 18.7892V0.274395C103.343 0.237541 103.347 0.199984 103.359 0.164676C103.37 0.129369 103.39 0.097272 103.416 0.0709101C103.442 0.0445481 103.474 0.024639 103.509 0.012747C103.544 0.000855084 103.581 -0.0026956 103.618 0.00237455H110.728C112.314 0.00237455 113.59 0.491703 114.554 1.47036ZM113.108 7.98222C113.776 7.32138 114.11 6.44815 114.11 5.36254C114.11 4.25602 113.777 3.36773 113.11 2.69767C112.443 2.02761 111.578 1.69228 110.515 1.69166H105.38C105.365 1.68861 105.35 1.6893 105.336 1.69369C105.321 1.69808 105.308 1.70602 105.297 1.7168C105.286 1.72758 105.278 1.74087 105.274 1.75547C105.27 1.77007 105.269 1.78553 105.272 1.80047V8.86651C105.269 8.88145 105.27 8.89691 105.274 8.91151C105.278 8.92611 105.286 8.9394 105.297 8.95018C105.308 8.96096 105.321 8.9689 105.336 8.97329C105.35 8.97767 105.365 8.97837 105.38 8.97532H110.515C111.577 8.9747 112.441 8.64367 113.108 7.98222Z"
      />
    </svg>
  );
};

// Set default icon color
//
// To add a new color, create a new case with the value and
// name of the color.

let fillColor;
const ColorSwitch = (propColor) => {
  switch (propColor) {
    case "green":
      fillColor = "#00FF7F";
      break;
    case "white":
      fillColor = "#FFFFFF";
      break;
    case "red":
      fillColor = "#FF0055";
      break;
    default:
      fillColor = "#000000";
      break;
  }
  return fillColor;
};

// Icons
//
// To add an icon, create an arrow function with the name of the icon,
// give it the input value "props", call the ColorSwitch function at
// the beginning with the value "props.color" and return the svg code.

const ArrowBackward = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
      ></path>
    </svg>
  );
};

const ArrowDown = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ArrowDropDown = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.66666 10.6665L12 15.9998L17.3333 10.6665H6.66666Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ArrowForward = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4L10.5867 5.41333L16.1733 11H4V13H16.1733L10.5867 18.5867L12 20L20 12L12 4Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Bin = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M15 3v2h6v2H3V5h6V3h6zM11 12H9v6h2v-6zM13 12h2v6h-2v-6z"
      ></path>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M7 22c-1.103 0-2-.897-2-2V8h14v12c0 1.103-.897 2-2 2H7zm10-12H7v10h10.001L17 10z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const Calendar = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5H19V2H17V7H16V5H9V2H7V7H6V5H4C2.897 5 2 5.898 2 7V20C2 21.103 2.897 22 4 22H20C21.103 22 22 21.103 22 20V7C22 5.898 21.103 5 20 5ZM19.997 20H4V9H20L19.997 20Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Clock = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C7.038 21 3 16.963 3 12C3 7.037 7.038 3 12 3C16.962 3 21 7.037 21 12C21 16.963 16.962 21 12 21ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z"
        fill={fillColor}
      />
      <path
        d="M14.293 15.707L11.293 12.707C11.105 12.519 11 12.265 11 12V7H13V11.586L15.707 14.293L14.293 15.707Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Done = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.00002 16.2001L4.80002 12.0001L3.40002 13.4001L9.00002 19.0001L21 7.0001L19.6 5.6001L9.00002 16.2001Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Download = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16.293 9.294l1.414 1.414L12 16.415l-5.707-5.707 1.414-1.414L11 12.587V2.001h2v10.586l3.293-3.293zM18 20.001v-2h2v2c0 1.102-.896 2-2 2H6c-1.104 0-2-.898-2-2v-2h2v2h12z"
      ></path>
    </svg>
  );
};

const FileDefault = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M6 2h9.414L20 6.586V20c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2V4c0-1.102.897-2 2-2zm0 18h12.001L18 8h-4V4H6v16z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const Hamburger = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="1" y="5" width="22" height="2" fill={fillColor} />
      <rect x="1" y="11" width="22" height="2" fill={fillColor} />
      <rect x="1" y="17" width="22" height="2" fill={fillColor} />
    </svg>
  );
};

const HamburgerClose = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="4.92896"
        y="3.51465"
        width="22"
        height="2"
        transform="rotate(45 4.92896 3.51465)"
        fill={fillColor}
      />
      <rect
        x="3.51471"
        y="19.0713"
        width="22"
        height="2"
        transform="rotate(-45 3.51471 19.0713)"
        fill={fillColor}
      />
    </svg>
  );
};

const Help = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12.092 6.241A3.84 3.84 0 008.16 9.982a.096.096 0 00.096.098h1.73c.05 0 .093-.04.095-.09A1.92 1.92 0 1112 12h-.864a.096.096 0 00-.096.096v1.728c0 .053.043.096.096.096H12a3.84 3.84 0 003.84-3.933 3.854 3.854 0 00-3.747-3.746zM12 16.8a.96.96 0 100-1.92.96.96 0 000 1.92z"
      ></path>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M12 2.4A9.6 9.6 0 002.4 12a9.6 9.6 0 009.6 9.6 9.6 9.6 0 009.6-9.6A9.6 9.6 0 0012 2.4zm0 17.28a7.68 7.68 0 110-15.36 7.68 7.68 0 010 15.36z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const Information = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
      ></path>
    </svg>
  );
};

const Mail = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Marker = (props) => {
  ColorSwitch(props.color);

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#00FF7F" />
      <path
        d="M13.06 7.72656L10 10.7799L6.94 7.72656L6 8.66656L10 12.6666L14 8.66656L13.06 7.72656Z"
        fill="#0A0A29"
      />
    </svg>
  );
};

const Payment = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Password = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M10.219 15.7292C10.219 16.5278 9.57163 17.1752 8.77303 17.1752C7.97442 17.1752 7.32703 16.5278 7.32703 15.7292C7.32703 14.9306 7.97442 14.2832 8.77303 14.2832C9.57163 14.2832 10.219 14.9306 10.219 15.7292Z"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.102 10.573L18.673 3L21.501 5.83L20.087 7.244L18.673 5.83L17.258 7.245L18.672 8.66L17.258 10.074L15.844 8.66L14.43 10.074L15.844 11.488L13.93 13.402L14.788 14.26C15.166 14.638 15.374 15.14 15.374 15.674C15.374 16.208 15.166 16.71 14.788 17.088L10.839 21.037C10.461 21.415 9.95898 21.623 9.42498 21.623C8.89098 21.623 8.38898 21.415 8.01097 21.037L3.46598 16.492C2.68698 15.714 2.68598 14.445 3.46498 13.664L7.41598 9.715C8.17198 8.959 9.48798 8.959 10.244 9.715L11.102 10.573ZM4.87998 15.077L9.42498 19.623L13.375 15.674L8.82998 11.129L4.87998 15.077Z"
      />
    </svg>
  );
};

const Phone = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Plus = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 11.001H13V3.00098H11V11.001H3V13.001H11V21.001H13V13.001H21V11.001Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Receipt = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 8H7V10H12V8Z" fill={fillColor} />
      <path d="M15 8H17V10H15V8Z" fill={fillColor} />
      <path d="M11 11H7V13H11V11Z" fill={fillColor} />
      <path d="M15 11H17V13H15V11Z" fill={fillColor} />
      <path d="M13 14H7V16H13V14Z" fill={fillColor} />
      <path d="M15 14H17V16H15V14Z" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.526 2.15C19.231 1.967 18.863 1.951 18.552 2.106L15.072 3.846L12.554 2.168C12.218 1.944 11.781 1.944 11.445 2.168L8.929 3.846L5.448 2.106C5.138 1.951 4.77 1.967 4.475 2.15C4.18 2.332 4 2.653 4 3V21C4 21.347 4.18 21.668 4.475 21.851C4.635 21.951 4.817 22 5 22C5.153 22 5.307 21.965 5.447 21.895L8.928 20.155L11.445 21.832C11.781 22.057 12.218 22.057 12.554 21.832L15.071 20.155L18.552 21.895C18.863 22.05 19.231 22.034 19.526 21.851C19.821 21.668 20 21.347 20 21V3C20 2.653 19.82 2.332 19.526 2.15ZM18 19.382L15.447 18.106C15.125 17.945 14.742 17.969 14.445 18.168L12 19.798L9.555 18.168C9.388 18.057 9.194 18 9 18C8.848 18 8.694 18.035 8.553 18.106L6 19.382V4.619L8.553 5.894C8.873 6.054 9.256 6.031 9.555 5.831L12 4.202L14.445 5.831C14.743 6.031 15.127 6.054 15.447 5.894L18 4.619V19.382Z"
        fill={fillColor}
      />
    </svg>
  );
};

const SadPin = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fillColor}
        d="M9.24926 14.3465C10.1274 14.1205 11.0489 14 12 14C12.9511 14 13.8726 14.1205 14.7507 14.3465C15.2856 14.4842 15.8308 14.1622 15.9684 13.6273C16.1061 13.0925 15.7841 12.5473 15.2493 12.4096C14.2097 12.142 13.1207 12 12 12C10.8793 12 9.79034 12.142 8.75074 12.4096C8.21589 12.5473 7.8939 13.0925 8.03156 13.6273C8.16922 14.1622 8.7144 14.4842 9.24926 14.3465Z"
      />
      <path
        fill={fillColor}
        d="M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z"
      />
      <path
        fill={fillColor}
        d="M15 11C16.1046 11 17 10.1046 17 9C17 7.89543 16.1046 7 15 7C13.8954 7 13 7.89543 13 9C13 10.1046 13.8954 11 15 11Z"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10C4 5.589 7.589 2 12 2C16.411 2 20 5.589 20 10C20 14.411 15.354 19.442 12 22.318C8.644 19.44 4 14.411 4 10ZM6 10C6 13.338 9.87 17.657 12 19.654C14.13 17.657 18 13.338 18 10C18 6.691 15.309 4 12 4C8.691 4 6 6.691 6 10Z"
      />
    </svg>
  );
};

const Search = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Substract = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M21 11.001H3V13.001H21V11.001Z" fill={fillColor} />
    </svg>
  );
};

const User = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.002 8C16.002 10.205 14.208 12 12.002 12C9.79701 12 8.00201 10.205 8.00201 8C8.00201 5.795 9.79601 4 12.002 4C14.208 4 16.002 5.795 16.002 8Z"
        fill={fillColor}
      />
      <path
        d="M4.00201 19C4.00201 15.467 7.29201 13 12.002 13C16.713 13 20.002 15.467 20.002 19V20H4.00201V19Z"
        fill={fillColor}
      />
    </svg>
  );
};

const UserFilled = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#0A0A29" rx="16"></rect>
      <path
        fill="#fff"
        d="M20.002 12c0 2.205-1.794 4-4 4-2.205 0-4-1.795-4-4s1.794-4 4-4 4 1.795 4 4zM8.002 23c0-3.533 3.29-6 8-6 4.711 0 8 2.467 8 6v1h-16v-1z"
      ></path>
    </svg>
  );
};

const ViewHide = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M22.8 3.2l-1.6-1.6L1.6 20.8l1.6 1.6 4.554-4.46c1.228.521 2.587.86 4.046.86 6.222 0 10.633-6.162 10.817-6.424a.996.996 0 000-1.15c-.105-.15-1.577-2.209-3.972-3.956L22.8 3.2zm-5.613 5.498l-1.666 1.633a4.004 4.004 0 01-5.266 5.159l-.923.903c.781.255 1.608.407 2.468.407 4.18 0 7.552-3.572 8.731-4.999-.604-.728-1.781-2.016-3.343-3.103zm-3.4 3.331a2.003 2.003 0 01-1.799 1.762l1.799-1.762z"
        clipRule="evenodd"
      ></path>
      <path
        fill={fillColor}
        d="M11.8 4.8c.89 0 1.742.126 2.55.343l-1.737 1.702A7.43 7.43 0 0011.8 6.8c-4.18 0-7.552 3.573-8.73 5a18.08 18.08 0 002.208 2.23l-1.44 1.411c-1.73-1.49-2.768-2.94-2.855-3.065a.996.996 0 010-1.15C1.167 10.961 5.578 4.8 11.8 4.8z"
      ></path>
    </svg>
  );
};

const ViewShow = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M11.8 7.8c-2.206 0-4 1.795-4 4 0 2.206 1.794 4 4 4s4-1.794 4-4c0-2.205-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2 0-1.102.897-2 2-2s2 .898 2 2c0 1.103-.897 2-2 2z"
        clipRule="evenodd"
      ></path>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M22.617 11.225C22.433 10.962 18.022 4.8 11.8 4.8S1.167 10.962.983 11.225a.996.996 0 000 1.15c.184.263 4.595 6.425 10.817 6.425s10.633-6.162 10.817-6.424a.996.996 0 000-1.151zM11.8 16.8c-4.166 0-7.549-3.575-8.73-5.001 1.178-1.426 4.55-5 8.73-5 4.166 0 7.549 3.577 8.731 5.002C19.352 13.228 15.98 16.8 11.8 16.8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

const Icons = {
  Logo,

  ArrowBackward,
  ArrowDown,
  ArrowDropDown,
  ArrowForward,
  Bin,
  Calendar,
  Clock,
  Done,
  Download,
  FileDefault,
  Hamburger,
  HamburgerClose,
  Help,
  Information,
  Mail,
  Marker,
  Payment,
  Password,
  Phone,
  Plus,
  Receipt,
  SadPin,
  Search,
  Substract,
  User,
  UserFilled,
  ViewHide,
  ViewShow,
};

export default Icons;
